// FIXME: add to @geoblocks/sources ?

import WMTSSource from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import {getTopLeft} from 'ol/extent.js';
import {proj as epsg2056} from '@geoblocks/proj/src/EPSG_2056.js';
import type {Options as WMTSOptions} from 'ol/source/WMTS';
import {RESOLUTIONS} from '../constants.ts';
import {getInitialSearchParams} from '../../urlHandling/urlSearchParams.ts';

type ImageExtension = 'jpeg' | 'png';

const swisstopoWMTSTileGrid = new WMTSTileGrid({
  origin: getTopLeft(epsg2056.getExtent()),
  extent: epsg2056.getExtent(),
  resolutions: RESOLUTIONS,
  matrixIds: RESOLUTIONS.map((_value, index) => String(index)),
});

export default class SwisstopoWMTS extends WMTSSource {
  constructor(
    layer: string,
    timestamp: string,
    extension: ImageExtension,
    options?: Partial<WMTSOptions>,
  ) {
    const tileCoordinateUrl = '2056/{TileMatrix}/{TileCol}/{TileRow}';

    let tilePixelRatio = 1;
    let zDirection = 0;

    const params = getInitialSearchParams();
    if (devicePixelRatio > 1) {
      tilePixelRatio = params.has('tilePixelRatio')
        ? parseInt(params.get('tilePixelRatio'))
        : 2;
      zDirection = params.has('zDirection')
        ? parseInt(params.get('zDirection'))
        : -1;
    }

    super(
      Object.assign(
        {
          url: `https://wmts100.geo.admin.ch/1.0.0/${layer}/default/{Time}/${tileCoordinateUrl}.${extension}`,
          layer: layer,
          projection: epsg2056,
          style: 'default',
          matrixSet: '2056',
          requestEncoding: 'REST',
          dimensions: {
            Time: timestamp,
          },
          tileGrid: swisstopoWMTSTileGrid,
          transition: 0,
          tilePixelRatio: tilePixelRatio,
          zDirection: zDirection,
          crossOrigin: 'anonymous',
        },
        options,
      ),
    );
  }
}
